import type { CompanyDomainValue } from "app/pages/sales-intelligence/domain/leads/types/website";
import { COLUMN_ECOMMERCE_SIGNAL_DATA } from "app/pages/sales-intelligence/sub-modules/signals/constants";
import { normalizeEcommerceSignalColumnCellValue } from "app/pages/sales-intelligence/sub-modules/signals/utils/normalizeEcommerceSignalColumnCellValue";
import { is } from "app/pages/sales-intelligence/utils/type-guards";

import type { BaseLeadsSearchRow, LeadsSearchRow } from "../types/rows";
import { leadRowTypeGuard } from "../types/type-guards";

export const findMainCompanyDomain = (companyDomains: readonly CompanyDomainValue[]): CompanyDomainValue | undefined =>
    companyDomains.find(({ isMainDomain }) => isMainDomain) ?? companyDomains[0];

export const getMainCompanyDomainOrDefault = <Row extends LeadsSearchRow>(row: Row | undefined): CompanyDomainValue => {
    const { company_domains } = row ?? {};

    if (is.undefined(company_domains) || company_domains === null || company_domains?.length === 0) {
        return {
            headQuarter: 0,
            domain: "",
            isMainDomain: false,
        };
    }

    return findMainCompanyDomain(company_domains)!;
};

export const getLeadDomainFromRow = <R extends BaseLeadsSearchRow>(tableRow: R | undefined): string => {
    if (leadRowTypeGuard.isWebsiteLeadRow(tableRow)) {
        return tableRow.site;
    }

    if (leadRowTypeGuard.isCompanyLeadRow(tableRow)) {
        return getMainCompanyDomainOrDefault(tableRow).domain;
    }

    return "";
};

function normalizeEcommerceSignalData(row: LeadsSearchRow): LeadsSearchRow {
    if (!(COLUMN_ECOMMERCE_SIGNAL_DATA in row)) {
        return row;
    }

    return {
        ...row,
        [COLUMN_ECOMMERCE_SIGNAL_DATA]: normalizeEcommerceSignalColumnCellValue(
            row[COLUMN_ECOMMERCE_SIGNAL_DATA as keyof LeadsSearchRow],
        ),
    };
}

export const transformRowDto = (rows: readonly LeadsSearchRow[]): readonly LeadsSearchRow[] => {
    return rows.map(normalizeEcommerceSignalData);
};
